<template>
  <div :class="$style.box" :style="{ minHeight: circleMinHeight }">
    <!-- 顶部说明栏 -->
    <div v-if="boxTitle" :class="[$style['top-bar'], showBorderBottom ? $style['border-top'] : '']">
      <!-- 左部小黄块 -->
      <span></span>
      <div :class="$style['title']">{{ boxTitle }}</div>
      <div v-if="headerRightText" :class="$style.right" @click="clickRightIcon">
        <div>{{ headerRightText }}</div>
        <van-icon
          name="arrow"
          style="position: relative; top: 2.5px; margin-left: 2px; font-size: 12px"
        ></van-icon>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { Icon } from 'vant';
export default {
  name: 'CircleBaseBox',
  components: {
    VanIcon: Icon
  },
  props: {
    boxTitle: {
      type: String,
      default: ''
    },
    headerRightText: {
      type: String,
      default: ''
    },
    showBorderBottom: {
      type: Boolean,
      default: true
    },
    circleMinHeight: {
      type: String,
      default: '95px'
    }
  },
  methods: {
    clickRightIcon() {
      this.$emit('clickRightIcon')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 361px;
  padding: 4px 10px 4px 10px;
  margin: auto;
  margin-bottom: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
  border-radius: 7px;
  .title {
    @include ellipsis(1);
    font-size: 13px;
    width: 0px;
    flex: 1;
    color: rgba(0, 0, 0, 1);
  }
  // 板块顶部说明栏通用样式
  .top-bar {
    width: 340px;
    height: 27px;
    padding: 4px 0px 7px 0px;
    margin-bottom: 1px;
    display: flex;
    & > span:nth-child(1) {
      display: inline-block;
      width: 4px;
      height: 13px;
      margin-right: 4px;
      margin-top: 1px;
      background: rgba(253, 146, 90, 1);
      border-radius: 2px;
    }
  }
  .right {
    display: flex;
    height: 17px;
    line-height: 17px;
    font-size: 10px;
    color: #969799;
  }
  .border-top {
    @include border-bottom-1px;
  }
}
</style>
